import Hammer from 'react-hammerjs';
import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable no-bitwise */
const Direction = {
    NONE: 1,
    LEFT: 2,
    RIGHT: 4,
    UP: 8,
    DOWN: 16,
    HORIZONTAL: 2 | 4, // LEFT | RIGHT
    VERTICAL: 8 | 16, // UP | DOWN
    ALL: 2 | 4 | 8 | 16, // LEFT | RIGHT | UP | DOWN
};
/* eslint-enable no-bitwise */

class SwipeHandler extends React.Component {
    static propTypes = {
        onSwipeLeft: PropTypes.func,
        onSwipeRight: PropTypes.func,
        onSwipeUp: PropTypes.func,
        onSwipeDown: PropTypes.func,
    };

    swipe = ({ direction }) => {
        if (direction === Direction.LEFT && typeof this.props.onSwipeLeft === 'function') {
            this.props.onSwipeLeft(this.props.children.props);
        } else if (direction === Direction.RIGHT && typeof this.props.onSwipeRight === 'function') {
            this.props.onSwipeRight(this.props.children.props);
        } else if (direction === Direction.UP && typeof this.props.onSwipeUp === 'function') {
            this.props.onSwipeUp(this.props.children.props);
        } else if (direction === Direction.DOWN && typeof this.props.onSwipeDown === 'function') {
            this.props.onSwipeDown(this.props.children.props);
        }
    };

    render() {
        const horizontal = typeof this.props.onSwipeLeft === 'function' || typeof this.props.onSwipeRight === 'function';
        const vertical = typeof this.props.onSwipeUp === 'function' || typeof this.props.onSwipeDown === 'function';
        this.direction = 'DIRECTION_NONE';
        if (horizontal && vertical) {
            this.direction = 'DIRECTION_ALL';
        } else if (horizontal) {
            this.direction = 'DIRECTION_HORIZONTAL';
        } else if (vertical) {
            this.direction = 'DIRECTION_VERTICAL';
        }

        return (
            <Hammer
                direction={this.direction}
                onSwipe={this.swipe}
            >
                <div style={{ width: '100%' }}>
                    {this.props.children}
                </div>
            </Hammer>
        );
    }
}

export default SwipeHandler;
